import {fetchWithToken} from "../../../api/apiBase";
import {useAuthInfo} from "@propelauth/react";
import {Link, useParams} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import {useToast} from "../../ui/use-toast";
import {BaseScopeModel, DeveloperScopeCardModel} from "../../scope/ScopeModel";
import BaseLoadingSpinner from "../../ui/baseLoadingSpinner";
import {DeveloperScopeCardMini} from "./ScopeListItem";
import {Card, CardContent, CardHeader, CardTitle} from "../../ui/card";
import ScrollTable, {Column} from "../../ui/ScrollableTable";
import {moneyFormatter} from "../../../lib/formatters";
import {AlertCircleIcon} from "lucide-react";
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from "../../ui/tooltip";
import {GoToScopesButton} from "../../navButtons/navButton";


function ScopesOverviewHeader() {

}


/** Below this many scopes the cards still fit on screen, above it use the table. */
const CARD_VIEW_MAX_SCOPES = 8;


/** Right aligned header, so the number columns line up with their cells. */
const numHeader = (label: string) => () => <div className="text-right pr-4">{label}</div>;


/** Same data as DeveloperScopeCardMini, as columns of a ScrollTable. */
function scopeColumns(project_id?: string): Column<any>[] {
    return [
        {
            header: "Scope",
            accessorKey: "number",
            cell: ({original}: { original: DeveloperScopeCardModel }) =>
                <div className="flex items-center gap-2">
                    <Link
                        className="font-semibold hover:underline"
                        to={`/project/${project_id}/scopes/${original.id}`}>
                        #{original.number} - {original.title}
                    </Link>
                    {original.num_bidders === 0 &&
                        <TooltipProvider>
                            <Tooltip>
                                <TooltipTrigger>
                                    <AlertCircleIcon color={"red"} size={16}/>
                                </TooltipTrigger>
                                <TooltipContent>
                                    <p>No Invites to this scope</p>
                                </TooltipContent>
                            </Tooltip>
                        </TooltipProvider>
                    }
                </div>
        },
        {
            header: numHeader("Invited"),
            accessorKey: "num_bidders",
            cell: ({original}: { original: DeveloperScopeCardModel }) =>
                <div className="text-right">{original.num_bidders}</div>
        },
        {
            header: numHeader("Submitted"),
            accessorKey: "num_bids",
            cell: ({original}: { original: DeveloperScopeCardModel }) =>
                <div className="text-right">{original.num_bids}</div>
        },
        {
            header: numHeader("Low"),
            accessorKey: "lowest_bid",
            cell: ({original}: { original: DeveloperScopeCardModel }) =>
                <div className="text-right">
                    {original.lowest_bid
                        ? <TooltipProvider>
                            <Tooltip>
                                <TooltipTrigger>
                                    <Link
                                        className="font-semibold hover:underline"
                                        to={`/project/${project_id}/bids/${original.lowest_bid.id}`}>
                                        {moneyFormatter.format(original.lowest_bid.bid_amount)}
                                    </Link>
                                </TooltipTrigger>
                                <TooltipContent>
                                    <p>Go to Low Bid</p>
                                </TooltipContent>
                            </Tooltip>
                        </TooltipProvider>
                        : <span className="text-gray-500">n/a</span>
                    }
                </div>
        },
    ];
}


/**
 * Scopes view for front Page
 * */
export function DeveloperScopesOverview() {
    const {accessToken} = useAuthInfo();
    const {project_id} = useParams<string>();
    const {toast} = useToast();
    const [data, setData] = useState<DeveloperScopeCardModel[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const fetchData = async () => {
        if (!accessToken) {
            return
        }
        try {
            setIsLoading(true);
            const response = await fetchWithToken(`/projects/${project_id}/scopes`, accessToken);
            setData(response);
            // console.log(response);
            setError(null);
        } catch (err) {
            setError("Error loading  :(");
            toast({
                title: "Error!",
                description: "Failed to load scopes",
                variant: "destructive",
            });
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        fetchData()
    }, [project_id, accessToken]);

    if (isLoading) return <div><BaseLoadingSpinner/></div>;
    if (error) return <div>Error loading Scope data :(</div>

    //const numInvites = 0;
    //const numBidders = 0;
    //const coverage = data.map(x => x.num_bidders > 0? 1 : 0);
    return <Card className="rounded-lg shadow">
        <CardHeader>
            <div className="flex justify-between items-center">
                <CardTitle>Scopes</CardTitle>
                <GoToScopesButton/>
            </div>

        </CardHeader>
        <CardContent>
            {data.length < CARD_VIEW_MAX_SCOPES
                ? <div className={"container grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3"}>
                    {data.map((qa: DeveloperScopeCardModel, index) =>
                        <DeveloperScopeCardMini key={index} scope={qa}/>)}
                </div>
                : <ScrollTable
                    columns={scopeColumns(project_id)}
                    data={data}
                    maxHeight="max-h-[60vh]"/>
            }
        </CardContent>
    </Card>

}
















